<script setup>

import StoreCreditSelected from "@/components/StoreCredit/StoreCreditSelected.vue";
import MoneyReturnSelected from "@/components/IbanReturn/MoneyReturnSelected.vue";
import VivaReturnSelected from "@/components/VivaReturn/VivaReturnSelected.vue";
import ShopifyReturnSelected from "@/components/ShopifyReturn/ShopifyReturnSelected.vue";
import {UseMoneyStore} from "@/stores/moneyStore";
import KlarnaReturnSelected from "@/components/KlarnaReturn/KlarnaReturnSelected.vue";

const moneyStore = UseMoneyStore();
</script>

<template>
  <div class="flex items-start bg-background-white border overflow-hidden container mx-auto px-6 py-3 mb-4">
    <StoreCreditSelected v-if="moneyStore.selectedHowReturnMoney === 'credit'"/>
    <MoneyReturnSelected v-if="moneyStore.selectedHowReturnMoney === 'iban'"/>
    <VivaReturnSelected v-if="moneyStore.selectedHowReturnMoney === 'viva'"/>
    <ShopifyReturnSelected v-if="moneyStore.selectedHowReturnMoney === 'shopify'"/>
    <KlarnaReturnSelected v-if="moneyStore.selectedHowReturnMoney === 'klarna'"/>
  </div>
</template>

<style scoped>

</style>